import React from 'react';
import Input from '../../../../../../components/Input';
import Popup from '../../../../../../components/Popup';

import './styles.css';


export function PopupSelectPartners(props) {
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle="Parceiros"
        >
            <div className='company-report-partners-popup-container'>
                <span className='tittle'>Escolha os parceiros para gerar um relatório:</span>
                <div>
                    <Input
                        type="checkbox"
                        placeholder="Selecionar Todos"
                        id="company-report-select-all-partners"
                        hideLabel
                        bold
                        checked={props.selectedPartners.length === props.partners.length}
                        onChange={(e) => {
                            if(e.target.checked)
                                props.setSelectedPartners(props.partners.map(obj => obj.id))
                            else
                                props.setSelectedPartners([])
                        }}
                    />
                    {
                        props.partners.map(obj => {
                            return (
                                <Input
                                    key={obj.id}
                                    type="checkbox"
                                    placeholder={obj.nome}
                                    //id="company-report-select-all-partners"
                                    hideLabel
                                    bold
                                    checked={props.selectedPartners.indexOf(obj.id) > -1}
                                    onChange={(e) => {
                                        if(e.target.checked)
                                            props.setSelectedPartners(oldArray => {
                                                const temp = [...oldArray];
                                                temp.push(obj.id)
                                                return temp;
                                            })
                                        else
                                            props.setSelectedPartners( oldArray => {
                                                const temp = [...oldArray];
                                                return temp.filter(value => value !== obj.id);
                                            })
                                    }}
                                />
                            )
                        })
                    }
                </div>
                <button onClick={() => props.setVisibility(false)}>Fechar</button>
            </div>
        </Popup>
    )
}